import { useCallback, useState } from 'react'
import Icon from '@mdi/react'

import {
  MobileInnerCloseBtn,
  MobileMenuHeader,
  MobileMenuHeaderInner,
  StyledMobileMenuInner,
} from './styles'
import HeaderLogo from 'components/Header/HeaderLogo'
import { mdiClose } from '@mdi/js'
import ScreenDefault from '../MobileMenuScreens/ScreenDefault'
import ScreenLanguage from './../MobileMenuScreens/ScreenLanguage'
import BaseMobileModal from 'components/Modal/BaseMobileModal'

interface MobileMenuInnerProps {
  handleClose: () => void
}

type ActiveScreensType = 'default' | 'language'

function MobileMenuInner(props: MobileMenuInnerProps) {
  const [activeScreen, setActiveScreen] = useState<ActiveScreensType>('default')

  const handleScreenDefault = useCallback(() => setActiveScreen('default'), [])

  return (
    <BaseMobileModal isOpen>
      <StyledMobileMenuInner>
        <MobileMenuHeader shouldHaveBg>
          <MobileMenuHeaderInner>
            <HeaderLogo />
            <MobileInnerCloseBtn onClick={props.handleClose}>
              <Icon path={mdiClose} size={1} color="#fff" />
            </MobileInnerCloseBtn>
          </MobileMenuHeaderInner>
        </MobileMenuHeader>

        {activeScreen === 'default' && (
          <ScreenDefault
            handleScreenLanguage={() => setActiveScreen('language')}
            handleCloseMenu={props.handleClose}
          />
        )}

        {activeScreen === 'language' && (
          <ScreenLanguage
            handleScreenDefault={handleScreenDefault}
            handleCloseMenu={props.handleClose}
          />
        )}
      </StyledMobileMenuInner>
    </BaseMobileModal>
  )
}

export default MobileMenuInner
